import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Check, Lock, Route } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StepDot = ({ m, last }) => {
  const done = m.status === 'completed';
  const current = m.status === 'current';
  return (
    <li className="relative flex-1 min-w-[84px] text-center" data-testid={`staff-pathways-step-${m.step}`} data-status={m.status} title={m.title}>
      {!last && <span className={`absolute top-4 left-1/2 w-full h-1 rounded-full ${done ? 'bg-primary' : 'bg-muted'}`} />}
      <span className={`relative z-10 mx-auto w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${
        done ? 'bg-primary text-primary-foreground' : current ? 'bg-background text-primary ring-4 ring-primary' : 'bg-muted text-muted-foreground'}`}>
        {done ? <Check className="w-4 h-4" /> : m.status === 'locked' ? <Lock className="w-3.5 h-3.5" /> : m.step}
      </span>
      <div className={`mt-1.5 text-[11px] font-semibold ${current ? 'text-primary' : ''}`}>Module {m.step}</div>
      <div className="text-[10px] text-muted-foreground leading-tight line-clamp-2 px-1">{m.title.replace(/^M\d+:\s*/, '')}</div>
      {current && <div className="text-[10px] font-semibold text-primary">{m.progress}% done</div>}
    </li>
  );
};

export const StaffPathwaysTracker = ({ participantId }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!participantId) return;
    axios.get(`${API}/participants/${participantId}/helpconnect-pathways`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [participantId]);
  if (!data?.pathways?.length) return null;
  const done = data.pathways.filter((m) => m.status === 'completed').length;
  return (
    <div className="pt-3 border-t" data-testid="staff-pathways-tracker">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h4 className="text-sm font-semibold flex items-center gap-2"><Route className="w-4 h-4 text-primary" />Pathways to Employability (HELPConnect)</h4>
        <span className="text-xs text-muted-foreground" data-testid="staff-pathways-count">{done} of {data.pathways.length} modules complete</span>
      </div>
      <ol className="flex overflow-x-auto pb-1">
        {data.pathways.map((m, i) => <StepDot key={m.step} m={m} last={i === data.pathways.length - 1} />)}
      </ol>
    </div>
  );
};
